module.exports = __webpack_public_path__ + "static/media/ip.bf65e925.jpg";